import React, { Fragment } from "react";
import blackBackground from "../../assets/pictures/old-black-background.jpg";
import { StateContext } from "../../containers/sidebarContext";
import CoverBoxes from "../CoverBoxes";
import { useTranslation } from "react-i18next";

const Bottle = () => {
  const state = React.useContext(StateContext);
  const { isSidebarOpen } = state;
  const { t } = useTranslation();

  const bottle = [
    { id: 1, title: "JACK DANIELS 0,7L", price: "110.00" },
    { id: 2, title: "JACK DANIELS GENTLMAN 0,7L", price: "130.00" },
    { id: 3, title: "CHIVAS 12 0,7L", price: "130.00" },
    { id: 4, title: "CHIVAS 18 0,7L", price: "165.00" },
    { id: 5, title: "JEGERMEISTER 0,7L", price: "75.00" },
    { id: 6, title: "GIN BOMBAY 0,7", price: "95.00" },
    { id: 7, title: "GIN MARE 0,7", price: "130.00" },
    { id: 8, title: "SMIRNOF 0,7", price: "95.00" },
    { id: 9, title: "BELVEDERE 0,7L", price: "130.00" },
    { id: 10, title: "GREY GOOSE 0,7L", price: "130.00" },
    { id: 11, title: "JOHNNY WALKER 0,7L", price: "75.00" },
    { id: 12, title: "STOCK 84 0,7L", price: "70.00" },
    { id: 12, title: "ASBACH 0,7L", price: "85.00" },
    { id: 13, title: "PELINKOVAC 1L", price: "85.00" },
    { id: 14, title: "PELINKOVAC ANTIQUE 0.7L", price: "75.00" },
  ];

  return (
    <Fragment>
      {isSidebarOpen && (
        <>
          <div
            style={{
              backgroundImage: `url(${blackBackground})`,
              backgroundSize: "cover",
            }}
            className="content bottle__box"
          >
            <div className="table__header">
              {" "}
              <h2>{t("bottles:bottles")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {bottle.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <CoverBoxes />
        </>
      )}
    </Fragment>
  );
};

export default Bottle;
